import React, { useEffect, useState } from 'react';

const CustomInstallBanner = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      // Предотвращаем стандартный браузерный баннер
      e.preventDefault();
      // Сохраняем событие для использования позже
      setDeferredPrompt(e);
      // Показываем баннер
      setVisible(true);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () =>
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
  }, []);

  const handleInstallClick = async () => {
    if (deferredPrompt) {
      // Показываем запрос на установку
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      console.log(`User response: ${outcome}`);
      // После выбором пользователем очищаем баннер
      setDeferredPrompt(null);
      setVisible(false);
    }
  };

  const handleClose = () => {
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      style={{
        width: '100%',
        backgroundColor: '#222629',
        color: '#fff',
        padding: '10px 12px',
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        boxShadow: '0px 2px 4px rgba(0,0,0,0.3)',
        fontFamily: 'sans-serif',
        fontSize: '14px',
        margin: '0',
        justifyContent: 'space-between',
        boxSizing: 'border-box'
      }}
    >
      <span style={{ flexGrow: 1 }}>
        Install Mailsball
      </span>
      <button
        onClick={handleInstallClick}
        style={{
          backgroundColor: '#86C232',
          color: '#fff',
          border: 'none',
          borderRadius: '4px',
          padding: '4px 8px',
          marginLeft: '8px',
          cursor: 'pointer',
          whiteSpace: 'nowrap',
          fontSize: '13px'
        }}
      >
        Install
      </button>
      <button
        onClick={handleClose}
        style={{
          backgroundColor: 'transparent',
          color: '#fff',
          border: 'none',
          fontSize: '16px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '16px',
          height: '16px',
          padding: 0,
          marginLeft: '4px'
        }}
      >
        &#x2715;
      </button>
    </div>
  );
};

export default CustomInstallBanner;
